import { useCallback, useState, useEffect } from 'react';
import { ValidationRules } from '../components/AttestationSection/AttestationSection.types';

export const useValidateManualFields = (
  manualFields: { [key: string]: string },
  t: (key: string) => string,
  optionalFields?: string[],
  validationRules?: ValidationRules,
) => {
  const filteredManualFields = Object.keys(manualFields)
    .filter((field) => !optionalFields?.includes(field))
    .reduce(
      (acc, field) => {
        acc[field] = manualFields[field];
        return acc;
      },
      {} as { [key: string]: string },
    );

  const initialErrors = Object.keys(manualFields).reduce(
    (acc, field) => {
      acc[field] = '';
      return acc;
    },
    {} as { [key: string]: string },
  );

  const [errors, setErrors] = useState(initialErrors);

  const validateManualFields = useCallback(() => {
    const newErrors = Object.keys(filteredManualFields).reduce(
      (acc, field) => {
        acc[field] = manualFields[field] ? '' : t('required');
        return acc;
      },
      {} as { [key: string]: string },
    );

    if (validationRules) {
      Object.entries(validationRules).forEach(([field, rule]) => {
        if (manualFields[field] && !newErrors[field]) {
          if (!rule.regex.test(manualFields[field])) {
            newErrors[field] = t(rule.errorKey);
          }
        }
      });
    }

    setErrors(newErrors);
    return newErrors;
  }, [manualFields, validationRules, t]);

  useEffect(() => {
    validateManualFields();
  }, [validateManualFields]);

  return { errors, validateManualFields };
};

export default useValidateManualFields;
